import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./LegalFooter.css";

export function LegalAcceptCheckbox({ checked, onChange, id = "legal-accept" }) {
  const { t } = useTranslation();
  return (
    <label className="legal-accept" htmlFor={id}>
      <input
        id={id}
        type="checkbox"
        checked={Boolean(checked)}
        onChange={(e) => onChange(e.target.checked)}
        required
      />
      <span>
        {t("legalContractRead", "I have read the")}{" "}
        <Link to="/privacy" target="_blank" rel="noopener noreferrer">
          {t("privacyPolicy", "Privacy notice")}
        </Link>{" "}
        {t("legalContractAndAccept", "and I accept the")}{" "}
        <Link to="/Termsofuse" target="_blank" rel="noopener noreferrer">
          {t("terms", "Terms of use")}
        </Link>
        {t(
          "legalContractWhichForm",
          ", which form the contract for my SmartTT account."
        )}
      </span>
    </label>
  );
}

export default LegalAcceptCheckbox;
